module.exports = __webpack_public_path__ + "img/vail_slide_3.1729adb3.jpg";